import React from 'react';
import { Music2, Users, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="om-oss" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold text-black leading-tight">
                {t('about.title')}
              </h2>
              <div className="w-20 h-1 bg-black"></div>
            </div>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              {t('about.intro')}
            </p>

            <div className="space-y-6 pt-6">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-black rounded-lg flex-shrink-0">
                  <Music2 className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-black mb-2">{t('about.feature1Title')}</h3>
                  <p className="text-gray-600">
                    {t('about.feature1Desc')}
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-black rounded-lg flex-shrink-0">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-black mb-2">{t('about.feature2Title')}</h3>
                  <p className="text-gray-600">
                    {t('about.feature2Desc')}
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-black rounded-lg flex-shrink-0">
                  <Heart className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-black mb-2">{t('about.feature3Title')}</h3>
                  <p className="text-gray-600">
                    {t('about.feature3Desc')}
                  </p>
                </div>
              </div>
            </div>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed pt-6 border-t border-gray-200">
              {t('about.availability')}
            </p>
          </div>

          {/* Right Column - Visual Element */}
          <div className="relative">
            <div className="aspect-square bg-white rounded-2xl shadow-xl p-12 flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_da9e6102-b17b-4e3a-82a5-102f912074e7/artifacts/esnq4twv_S2R_logo_750x750.png"
                alt="S2R Logo"
                className="w-full h-full object-contain"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-black rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 border-4 border-black rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;